import type { TypedAddListener } from '@reduxjs/toolkit';
import {
  addListener as addListenerUntyped,
  createListenerMiddleware as rtkCreateListenerMiddleware,
} from '@reduxjs/toolkit';
import { Dispatch, State } from '../../client/configureStore';
import { ListenerMiddleWareExtraArguments } from './listenerMiddlewareTypes';

export const addListener = addListenerUntyped as TypedAddListener<
  State,
  Dispatch,
  ListenerMiddleWareExtraArguments
>;

export const createListenerMiddleware = (
  extraArguments: ListenerMiddleWareExtraArguments
) => {
  const listenerMiddleware = rtkCreateListenerMiddleware({
    extra: extraArguments,
  });

  return listenerMiddleware;
};
